module.exports = __webpack_public_path__ + "static/media/Geometry-2.fb9febc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/subject_icons/Geometry-2.svg
// module id = 888
// module chunks = 21